import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from "contentful";
import type { TypeTableOfContentsSettingSkeleton } from "./TypeTableOfContentsSetting";

/**
 * Fields type definition for content type 'TypeVideoSection'
 * @name TypeVideoSectionFields
 * @type {TypeVideoSectionFields}
 * @memberof TypeVideoSection
 */
export interface TypeVideoSectionFields {
    /**
     * Field type definition for field 'internalTitle' (Internal Title)
     * @name Internal Title
     * @localized false
     */
    internalTitle?: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'title' (Title)
     * @name Title
     * @localized false
     */
    title?: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'videoEmbed' (Video Embed)
     * @name Video Embed
     * @localized false
     */
    videoEmbed?: EntryFieldTypes.Text;
    /**
     * Field type definition for field 'tocSetting' (tocSetting)
     * @name tocSetting
     * @localized false
     */
    tocSetting?: EntryFieldTypes.EntryLink<TypeTableOfContentsSettingSkeleton>;
}

/**
 * Entry skeleton type definition for content type 'videoSection' (Video Section)
 * @name TypeVideoSectionSkeleton
 * @type {TypeVideoSectionSkeleton}
 * @author 7BjsgI9gzpO6Dv7BH5AOT6
 * @since 2018-03-28T13:15:08.094Z
 * @version 11
 */
export type TypeVideoSectionSkeleton = EntrySkeletonType<TypeVideoSectionFields, "videoSection">;
/**
 * Entry type definition for content type 'videoSection' (Video Section)
 * @name TypeVideoSection
 * @type {TypeVideoSection}
 * @author 7BjsgI9gzpO6Dv7BH5AOT6
 * @since 2018-03-28T13:15:08.094Z
 * @version 11
 */
export type TypeVideoSection<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<TypeVideoSectionSkeleton, Modifiers, Locales>;

export function isTypeVideoSection<Modifiers extends ChainModifiers, Locales extends LocaleCode>(entry: Entry<EntrySkeletonType, Modifiers, Locales>): entry is TypeVideoSection<Modifiers, Locales> {
    return entry.sys.contentType.sys.id === 'videoSection'
}
